/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLayerPayloadDto
 */
export interface UpdateLayerPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    limitType?: UpdateLayerPayloadDtoLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    limit?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    excess?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    deductibles?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    premium?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    totalDeductions?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLayerPayloadDto
     */
    lineSize?: string;
}


/**
 * @export
 */
export const UpdateLayerPayloadDtoLimitTypeEnum = {
    Primary: 'Primary',
    ExcessOfLoss: 'Excess of Loss',
    QuotaShare: 'Quota Share'
} as const;
export type UpdateLayerPayloadDtoLimitTypeEnum = typeof UpdateLayerPayloadDtoLimitTypeEnum[keyof typeof UpdateLayerPayloadDtoLimitTypeEnum];


/**
 * Check if a given object implements the UpdateLayerPayloadDto interface.
 */
export function instanceOfUpdateLayerPayloadDto(value: object): value is UpdateLayerPayloadDto {
    return true;
}

export function UpdateLayerPayloadDtoFromJSON(json: any): UpdateLayerPayloadDto {
    return UpdateLayerPayloadDtoFromJSONTyped(json, false);
}

export function UpdateLayerPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLayerPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'limitType': json['limitType'] == null ? undefined : json['limitType'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'excess': json['excess'] == null ? undefined : json['excess'],
        'deductibles': json['deductibles'] == null ? undefined : json['deductibles'],
        'premium': json['premium'] == null ? undefined : json['premium'],
        'totalDeductions': json['totalDeductions'] == null ? undefined : json['totalDeductions'],
        'lineSize': json['lineSize'] == null ? undefined : json['lineSize'],
    };
}

export function UpdateLayerPayloadDtoToJSON(json: any): UpdateLayerPayloadDto {
    return UpdateLayerPayloadDtoToJSONTyped(json, false);
}

export function UpdateLayerPayloadDtoToJSONTyped(value?: UpdateLayerPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limitType': value['limitType'],
        'limit': value['limit'],
        'excess': value['excess'],
        'deductibles': value['deductibles'],
        'premium': value['premium'],
        'totalDeductions': value['totalDeductions'],
        'lineSize': value['lineSize'],
    };
}

